import {BaseService} from "@Services/base.service";


export class InvoiceService extends BaseService{

	public getInvoiceList(page: number): Promise<any> {
		return super.get(`/stripe-invoices/${page}/`)
	}
}
